import i18n from "../../../constants/i18n";
import { getPermissionIDRequired } from "../../../helpers/et3-has-permission";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getDashBoardStore from "../../../stores/dashboard-store";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import HeaderMenuItem from "../HeaderMenuItem";
import {
  HEADER_MENU_GAP,
  HEADER_MENU_HEIGHT,
  HEADER_MENU_WIDTH
} from "../header-constants";

const NoneKhattabaMenu = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const approvalCount = getDashBoardStore().approvalCount.get();
  const reportCount = getDashBoardStore().reportsCount.get();
  const reportedCount = getDashBoardStore().reportedCount.get();
  const alertsCount = getDashBoardStore().getAlertsCounts.get();
  const investigationCasesCount =
    getDashBoardStore().investigationCasesCount.get();
  const adminIsUnderMaintenance =
    getCorePersonalStore().adminUnderMaintenance.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={HEADER_MENU_WIDTH}
      height={HEADER_MENU_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: HEADER_MENU_GAP * unitX
      }}
      onClick={() => {}}
    >
      <HeaderMenuItem
        isSelected={getCoreHistoryStore().getPageName() === "ALARMS"}
        text={i18n.get("ALARMS")}
        counter={`${alertsCount}`}
        link="/alarms"
        enabled={
          userPermissions.indexOf(getPermissionIDRequired("Alarms")) > -1 &&
          !adminIsUnderMaintenance
        }
      />
      <HeaderMenuItem
        isSelected={getCoreHistoryStore().getPageName() === "APPROVAL_DATA"}
        text={i18n.get("APPROVE_REJECT_DATA")}
        counter={`${approvalCount}`}
        link="/approveReject"
        enabled={
          userPermissions.indexOf(getPermissionIDRequired("Approve-Reject")) >
            -1 && !adminIsUnderMaintenance
        }
      />
      <HeaderMenuItem
        isSelected={getCoreHistoryStore().getPageName() === "REPORTS"}
        text={i18n.get("REPORTS")}
        counter={`${reportCount}-${reportedCount}`}
        link="/reports"
        enabled={
          userPermissions.indexOf(getPermissionIDRequired("Reports")) > -1 &&
          !adminIsUnderMaintenance
        }
      />
      <HeaderMenuItem
        isSelected={
          getCoreHistoryStore().getPageName() === "INVESTIGATION_CASES"
        }
        text={i18n.get("INVESTIGATION_CASES")}
        counter={`${investigationCasesCount}`}
        link="/investigationCases"
        enabled={
          userPermissions.indexOf(
            getPermissionIDRequired("Investigation-Case")
          ) > -1 && !adminIsUnderMaintenance
        }
      />
    </ET3Div>
  );
});

export default NoneKhattabaMenu;
